/**
 * Overlay focus vs Phaser keyboard. Scenes register a callback; they do not
 * attach listeners to `#ui-root`.
 */

export function isTypingInField(): boolean {
  const target = document.activeElement;

  if (!(target instanceof HTMLElement)) {
    return false;
  }

  if (target.isContentEditable) {
    return true;
  }

  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT';
}

export type OverlayTypingListener = (typing: boolean) => void;

/**
 * Calls `onTyping` when a field under `#ui-root` gains or loses focus.
 * Returns an unsubscribe that also reports `false`.
 */
export function bindOverlayTyping(onTyping: OverlayTypingListener): () => void {
  const overlay = document.getElementById('ui-root');

  const onFocusIn = (): void => {
    if (isTypingInField()) {
      onTyping(true);
    }
  };
  const onFocusOut = (): void => {
    onTyping(false);
  };

  overlay?.addEventListener('focusin', onFocusIn);
  overlay?.addEventListener('focusout', onFocusOut);

  return () => {
    overlay?.removeEventListener('focusin', onFocusIn);
    overlay?.removeEventListener('focusout', onFocusOut);
    onTyping(false);
  };
}
